export const INSUFFICIENT_USER_PERMISSION_EMPTY_STATE_TITLE = 'Not enough permission';
export const INSUFFICIENT_USER_PERMISSION_EMPTY_STATE_SUBTITLE =
  'Your user role does not provide access to this action.';
export const INSUFFICIENT_USER_PERMISSION_EMPTY_STATE_BUTTON_LABEL = 'Back to products';
export const INSUFFICIENT_USER_PERMISSION_EMPTY_STATE_DIV_DATA_CY = 'insufficient-user-permission-empty-state';
